export const numberToCurrency = (number: number, format: boolean) => {
    if (number && format) {
        var formatter = new Intl.NumberFormat('nl-NL', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });
        return formatter.format(number);
    } else {
        return `€${number}`;
    }
};
